const routes = [
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      { path: '', name: 'HomeScreen', component: () => import('pages/Index.vue') },
      { path: 'config', name: 'Config', component: () => import('pages/Config.vue') },
      { path: 'orderComplete', name: 'OrderComplete', component: () => import('pages/ThankYou.vue') },
    ],
  },
];

// Always leave this as last one
routes.push({
  path: '*',
  component: () => import('pages/Error404.vue'),
});

export default routes;
